// extracted by mini-css-extract-plugin
export default {"wrapper":"account-details_wrapper__oypZv","name":"account-details_name__Rv93a","number":"account-details_number__KaFdB"};